import { Container } from "./styles";
import { useForm, ValidationError } from '@formspree/react';

export function Form(){


  const [state, handleSubmit] = useForm("xoqrvlzv");
  
  return(
    <Container>
      <h2>Get in touch using the form below.</h2>
      <form onSubmit={handleSubmit} method="POST">
        <input
          placeholder="Email"
          id="email"
          type="email" 
          name="email"
        />
        <ValidationError 
          prefix="Email" 
          field="email"
          errors={state.errors}
        />
        <textarea
          placeholder="Leave your message"
          id="message"
          name="message"
        />
        <ValidationError 
          prefix="Message" 
          field="message"
          errors={state.errors}
        />
        <button type="submit">
          Send to me
        </button>
    </form>
    </Container>
  )
}